import cx from "classnames";
import { useTranslation } from "next-i18next";

import { Button, LoadingSpinner, Text } from "@/components/elements";
import { ServerError } from "@/components/ServerError";
import { FormProps } from "@/types/types";

import styles from "./styles.module.css";

export const Form = ({
  legend,
  hideLegend = false,
  formDescription,
  footerContent,
  children,
  disabled = false,
  isLoading = false,
  serverError,
  primaryButtonText,
  primaryButtonTheme = "dark",
  secondaryButtonEnhancerStart,
  secondaryButtonText,
  secondaryButtonAction,
  ...props
}: FormProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ServerError
        error={serverError}
        className={styles.serverErrorContainer}
      />

      <form noValidate className={styles.form} {...props}>
        <div className={styles.fieldsetWrapper}>
          <fieldset>
            {legend && (
              <Text
                as="legend"
                size="l"
                className={cx(
                  styles.legend,
                  { visuallyhidden: hideLegend },
                  { [styles.noDescription]: !formDescription }
                )}
              >
                {legend}
              </Text>
            )}

            {formDescription && (
              <Text size="xs" className={styles.formDescription}>
                {formDescription}
              </Text>
            )}

            {children}
          </fieldset>
        </div>

        <div className={styles.formFooter}>
          {footerContent}
          <Button
            theme={primaryButtonTheme}
            type="submit"
            disabled={disabled}
            width="full"
          >
            {isLoading ? (
              <LoadingSpinner size="small" />
            ) : (
              primaryButtonText || t("submit")
            )}
          </Button>
          {(secondaryButtonEnhancerStart || secondaryButtonText) && (
            <div className={styles.secondaryCTA}>
              {secondaryButtonEnhancerStart}
              {secondaryButtonText && (
                <Button
                  theme="underline"
                  size="small"
                  onClick={secondaryButtonAction}
                  className={styles.secondaryButton}
                >
                  {secondaryButtonText}
                </Button>
              )}
            </div>
          )}
        </div>
      </form>
    </>
  );
};
